import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Divider as MuiDivider } from '@mui/material'

import useStyles from './styles'

const Divider = ({
  hideStart,
  hideEnd,
  variant,
  animated,
  hasSmallDots,
  ...props
}) => {
  const classes = useStyles()

  return (
    <MuiDivider
      classes={{
        inset: classes.inset,
        vertical: classes.vertical,
        middle: classes.middle,
      }}
      className={clsx({
        [classes.hiddenStart]: variant !== 'middle' && hideStart,
        [classes.hiddenEnd]: variant !== 'middle' && hideEnd,
        [classes.animated]: variant !== 'middle' && animated,
        [classes.hasSmallDots]: variant !== 'middle' && hasSmallDots,
      })}
      variant={variant}
      {...props}
    />
  )
}

Divider.propTypes = {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  variant: PropTypes.oneOf(['inset', 'middle']),
  hideStart: PropTypes.bool,
  hideEnd: PropTypes.bool,
  animated: PropTypes.bool,
  light: PropTypes.bool,
  hasSmallDots: PropTypes.bool,
}

export default Divider
